import http from '@/libs/axios'

export function getAllNotifications(params) {
  return http({
    url: '/chat/notifications/',
    method: 'GET',
    params: params
  })
}

export function getNotificationsSetNotif() {
  return http({
    url: '/chat/notifications/set_notif/',
    method: 'GET',
  })
}
